import React, { Component } from "react";
import { Form } from "react-form";
import sha256 from "js-sha256";
import TextFields from "../UI/TextFiled";
import SelectMenu from "../UI/Select";
import RadioGroup from "../UI/Radio";
import SwitchToggle from "../UI/SwitchToggle";
import ImageUpload from "../UI/ImageUpload";
import Breadcrumb from "../UI/Breadcrumb";
import InputTabs from "../UI/InputTabs";
import PageTitle from "../UI/PageTitle";
import { connect } from "react-redux";
import { addDriver, getZones } from "../../store/actions";
import { breadcrumbs, COLORS, validate } from "../../utils/constants";

class AddDriver extends Component {
  state = {
    defaultValues: {
      transport_type: "normal",
      work_type: "Full-time",
      is_active: true
    },
    firstName: {
      eng: true,
      arb: false
    },
    lastName: {
      eng: true,
      arb: false
    }
  };

  componentDidMount() {
    this.props.getZones();
  }

  onFormSubmitHandler = submittedValues => {
    const data = {
      driver_iqama_saudi_id: submittedValues.driver_iqama_saudi_id,
      image: submittedValues.image,
      first_name_en: submittedValues.first_name_en,
      first_name_ar: submittedValues.first_name_ar,
      last_name_en: submittedValues.last_name_en,
      last_name_ar: submittedValues.last_name_ar,
      mobile_number: submittedValues.mobile_number,
      email: submittedValues.email,
      password: sha256(submittedValues.password),
      agreed_deposit: +submittedValues.agreed_deposit,
      transport_model: submittedValues.transport_model,
      transport_year: submittedValues.transport_year,
      license_plate: submittedValues.license_plate_en,
      transport_color: submittedValues.transport_color,
      transport_type: submittedValues.transport_type,
      work_type: submittedValues.work_type,
      agreed_fixed_salary: +submittedValues.agreed_fixed_salary,
      is_active: submittedValues.is_active,
      zone: submittedValues.zona
    };

    this.props.addDriver(data).then(res => this.props.history.push("/drivers"));
  };

  onFormChangeHandler = (formState, formApi) => {
    if (formState.touched && formState.touched.firstName_ar) {
      formApi.setTouched("firstName_en", true);
    }

    if (formState.touched && formState.touched.firstName_en) {
      formApi.setTouched("firstName_ar", true);
    }

    if (formState.touched && formState.touched.lastName_ar) {
      formApi.setTouched("lastName_en", true);
    }

    if (formState.touched && formState.touched.lastName_en) {
      formApi.setTouched("lastName_ar", true);
    }
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle title="Add new driver" />
        <div className="container">
          <Breadcrumb from={breadcrumbs.driver} current="Add Drivers" />
        </div>

        <div className="container box inner-padding mb-15">
          <Form
            onSubmit={this.onFormSubmitHandler}
            onChange={this.onFormChangeHandler}
            defaultValues={this.state.defaultValues}
          >
            {formApi => (
              <form onSubmit={formApi.submitForm}>
                <div className="box-body">
                  <div className="row justify-between">
                    <div className="col-xs-6 pr-70">
                      <TextFields
                        validations={[...validate.$tenNumbers]}
                        type="text"
                        label="Driver Iqama/Saudi ID"
                        field="driver_iqama_saudi_id"
                      />
                      <ImageUpload
                        validations={[...validate.$image]}
                        label="Driver Image"
                      />
                      <InputTabs
                        validations={[...validate.$text]}
                        formApi={formApi}
                        field="firstName"
                        label="Driver First Name"
                        value="first_name"
                      />
                      <InputTabs
                        validations={[...validate.$text]}
                        formApi={formApi}
                        field="lastName"
                        label="Driver Last Name"
                        value="last_name"
                      />
                      <TextFields
                        mobile
                        defaultValue="+9665"
                        validations={[...validate.$mobile]}
                        formApi={formApi}
                        type="text"
                        label="Driver Mobile Number"
                        field="mobile_number"
                      />
                      <TextFields
                        validations={[...validate.email]}
                        type="text"
                        label="Driver Email"
                        field="email"
                      />
                      <TextFields
                        validations={[...validate.$upToSixNumbersAndLetters]}
                        type="password"
                        label="Driver Password"
                        field="password"
                      />
                      {this.props.zones ? (
                        <SelectMenu
                          formApi={formApi}
                          field="zona"
                          label="Agreed Zone"
                          menu={this.props.zones}
                        />
                      ) : null}
                    </div>
                    <div className="col-xs-6 pl-70">
                      <TextFields
                        validations={[...validate.$money]}
                        type="text"
                        label="Agreed Deposit"
                        field="agreed_deposit"
                      />
                      <div className="row">
                        <div className="col-xs-12 mt-20">
                          <p className="color-grey50 font-sm w-700">
                            Transport Description
                          </p>
                        </div>
                        <div className="col-xs-3">
                          <TextFields
                            validations={[...validate.$year]}
                            type="text"
                            label="Year"
                            field="transport_year"
                          />
                        </div>
                        <div className="col-xs-9">
                          <TextFields
                            validations={[...validate.$numbersAndLetters]}
                            type="text"
                            label="Model"
                            field="transport_model"
                          />
                        </div>
                      </div>

                      <InputTabs
                        validations={[...validate.$licensePlate]}
                        formApi={formApi}
                        field="license_plate"
                        label="License Plate"
                        value="license_plate"
                      />

                      <SelectMenu
                        field="transport_color"
                        label="Color"
                        menu={COLORS}
                      />

                      <div className="mt-25">
                        <p className="color-grey50 font-sm w-700 pb-10">
                          Transport Type
                        </p>
                        <RadioGroup
                          labelFirst="Cooled"
                          valueFirst="cooled"
                          labelSecond="Normal"
                          valueSecond="normal"
                          field="transport_type"
                        />
                      </div>

                      <div className="mt-25 mb-15">
                        <p className="color-grey50 font-sm w-700 pb-10">
                          Full Time or Part Time
                        </p>
                        <RadioGroup
                          labelFirst="Full"
                          valueFirst="Full-time"
                          labelSecond="Part"
                          valueSecond="Part-time"
                          field="work_type"
                        />
                      </div>
                      {formApi.values.work_type === "Full-time" && (
                        <TextFields
                          validations={[...validate.$money]}
                          type="text"
                          label="Agreed Fixed Salary"
                          field="agreed_fixed_salary"
                        />
                      )}
                      <div className="mt-25">
                        <p className="color-grey50 font-sm w-700">
                          Driver Status
                        </p>
                        <div className="flex-center-y mt-20">
                          <span className="color-grey50 w-600 mr-15">
                            Inactive
                          </span>
                          <SwitchToggle toggled={true} field="is_active" />
                          <span className="color-primary w-600 ml-25">
                            Active
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="box-meta">
                  <div className="text-right">
                    <button className="no-style w-600 pointer mx-20">
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn filled primary min-120"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

const mapPropsToProps = state => {
  return {
    zones: state.customer.zones
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addDriver: data => dispatch(addDriver(data)),
    getZones: () => dispatch(getZones())
  };
};

export default connect(
  mapPropsToProps,
  mapDispatchToProps
)(AddDriver);



// WEBPACK FOOTER //
// ./src/components/Driver/AddDriver.js